import Localstorage from "./localstorage";

const clone = (data) => {
    return JSON.parse(JSON.stringify(data));
}

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, 'g'), replace);
}

const rad = (d) => {
    return d * Math.PI / 180.0;
}
const getDistance = (lat1, lng1, lat2, lng2) => {
    var radLat1 = rad(lat1);
    var radLat2 = rad(lat2);
    var a = radLat1 - radLat2;
    var b = rad(lng1) - rad(lng2);
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137;
    s = Math.round(s * 10000) / 10000;
    return s;
}


const formatDate = (d, tail) => {
    var format = function (d, fmt) { //author: meizz 
        var o = {
            "M+": d.getMonth() + 1, //月份 
            "d+": d.getDate(), //日 
            "h+": d.getHours(), //小时 
            "m+": d.getMinutes(), //分 
            "s+": d.getSeconds(), //秒 
            "q+": Math.floor((d.getMonth() + 3) / 3), //季度 
            "S": d.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    var t = format(d, 'yyyy-MM-dd')
    if (tail) {
        t += tail
    }
    return t
}


const randomColor = () => {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

const getMinDisplay = (time) => {
    let hour = parseInt(time / 60)
    let min = +((time / 60).toFixed(2).split('.')[1])
    let res = []
    if (hour >= 1) {
        res.push(hour + 'h')
    }
    if (min > 0) {
        res.push((min * 60 / 100).toFixed(0) + 'm')
    }
    return res.join(' ')
}

export default {
    getDistance: getDistance,
    getMinDisplay: getMinDisplay,
    localstorage: Localstorage,
    clone: clone,
    formatDate: formatDate,
    randomColor: randomColor,
    replaceAll: replaceAll
}
